import request from '@/utils/request';

export function getDistList() {
	return new Promise((resolve, reject) => {
		request();
	});
}
